import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'eyrus-question-type-modal',
  templateUrl: './question-type-modal.component.html',
  styleUrls: ['./question-type-modal.component.sass']
})
export class QuestionnaireQuestionTypeModalComponent implements OnInit {

  @Input() questionTypes: Array<any> = [];

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  confirm() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

  /**
   * Emit selected option result
   * @param option value selected
   */
  selectOption(option) {
    this.activeModal.close(option);
  }

}
